import React from 'react';
import clazz from 'classnames';
import drawerStyle from '../_style/drawer.less';
import { Icon } from 'antd';
class DrawerView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowAll: null,
        };
        this.changeShow = this.changeShow.bind(this);
    }
    changeShow() {
        this.setState({
            isShowAll: this.state.isShowAll === null ? false : !this.state.isShowAll,
        });
    }
    componentDidUpdate() {
        setTimeout(() => {
            this.props.onShowChange && this.props.onShowChange(this.state.isShowAll === null ? false : this.state.isShowAll);
        });
    }
    render() {
        const { position, iconOpen, iconContract, title, operateNode, } = this.props;
        const { isShowAll } = this.state;
        return (<div className={clazz(drawerStyle.drawer, isShowAll === false ? drawerStyle.contract : isShowAll === true ? drawerStyle.open : drawerStyle.init, position === 'left' ? drawerStyle.left : drawerStyle.right)}>
        <div className={drawerStyle.header}>
          <div className={drawerStyle.drawerTitle} onClick={this.changeShow}>
            <span className={drawerStyle.text}>
              {isShowAll === false ? (title.contract || '展开') : (title.open || '收起')}
            </span>
            {isShowAll === false ? iconContract : iconOpen}
          </div>
          <div className={drawerStyle.operate}>
            {operateNode}
          </div>
        </div>
        <div className={drawerStyle.content}>
          {this.props.children}
        </div>
      </div>);
    }
}
DrawerView.defaultProps = {
    position: 'right',
    iconOpen: (<Icon type="double-right" style={{
        fontSize: '16px',
    }}/>),
    iconContract: (<Icon type="double-left" style={{
        fontSize: '16px',
    }}/>),
    title: {
        open: '收起',
        contract: '展开',
    },
    operateNode: null,
};
export default DrawerView;
